var render = function render(_c,_vm){return _c('v-sheet',{staticClass:"overflow-y-auto",staticStyle:{"max-height":"256px"}},[_c('pre',[_vm._v("    "+_vm._s(JSON.stringify(_vm.data.attrs, null, 2))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }